/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.styles';

const isNumber = input => /\d/.test(input);

export class NumberPicker extends SafePureComponent {
  inputRef = React.createRef();

  isDecreaseDisabled = () => {
    const { value, min } = this.props;
    return Number(value) === min;
  };

  isIncreaseDisabled = () => {
    const { value, max } = this.props;
    return Number(value) === max;
  };

  decrease = () => {
    const { min, onChange, value } = this.props;
    onChange(Math.max(min, Number(value) - 1));
  };

  increase = () => {
    const { max, onChange, value } = this.props;
    onChange(Math.min(max, Number(value) + 1));
  };

  onInputKeyPress = e => {
    if (!isNumber(e.key)) {
      e.preventDefault();
      return;
    }
  };

  onInputPaste = e => {
    e.preventDefault();
  };

  onInputChange = e => {
    const rawValue = e.target.value;
    const { max, onChange } = this.props;
    const value = Number(rawValue) > max ? String(max) : rawValue;

    onChange(value);
  };

  safeRender() {
    const { id, label, value, numberLabel, min, innerCss } = this.props;

    return (
      <div css={innerCss.container}>
        <label css={[styles.label, innerCss.label]} htmlFor={id}>
          {label}
        </label>
        <div css={[styles.controls, innerCss.controls]}>
          <button
            css={styles.numberButton}
            onClick={this.decrease}
            onMouseDown={this.decreaseWhilePressed}
            aria-label="decrease"
            type="button"
            disabled={this.isDecreaseDisabled()}
          >
            -
          </button>
          <input
            css={styles.input}
            ref={this.inputRef}
            type="text"
            id={id}
            name={id}
            onKeyPress={this.onInputKeyPress}
            onPaste={this.onInputPaste}
            onChange={this.onInputChange}
            placeholder={`${min} ${numberLabel}`}
            autoComplete="off"
            value={value}
          />
          <button
            css={styles.numberButton}
            onClick={this.increase}
            aria-label="increase"
            type="button"
            disabled={this.isIncreaseDisabled()}
          >
            +
          </button>
        </div>
      </div>
    );
  }
}

NumberPicker.displayName = 'NumberPicker';

NumberPicker.defaultProps = {
  id: '',
  label: '',
  value: '',
  min: 0,
  max: 1,
  numberLabel: '',
  innerCss: {},
  onChange() {},
};

NumberPicker.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.number,
  max: PropTypes.number,
  numberLabel: PropTypes.string,
  innerCss: PropTypes.any,
  onChange: PropTypes.func,
};

export default NumberPicker;
